<template>
  <collapsible-widget
    title="WARSTWY ARCHIWALNE"
    :maxHeight="30"
    :expand-widget="archiveLayersExpanded"
    :accordion="accordion"
    @toggled="onToggled"
    ref="collapsible"
    :default-expanded="archiveLayersExpanded"
    :selectAllEnabled="archiveLayersHasItems"
    :onCheckboxChanged="onCheckboxChanged"
    :allSelected.sync="allSelected"
    :indeterminate="indeterminate"
  >
    <composition-layers
      :layers="archiveLayers"
      @set-layer-extent="setLayerExtent"
    ></composition-layers>
  </collapsible-widget>
</template>

<script>
import { mapGetters } from 'vuex';
import CollapsibleWidget from './CollapsibleWidget';
import CompositionLayers from './CompositionLayers';
import {
  ARCHIVE_LAYERS_EXPANDED_SET,
  SET_LAYER_VISIBILITY
} from '../store/mutations.type';

export default {
  name: 'Compositions',
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget,
    CompositionLayers
  },
  computed: {
    ...mapGetters(['readOnly', 'archiveLayersExpanded']),
    archiveLayers() {
      return Array(
        ...this.$store.getters.archiveLayers.sort((a, b) => {
          return b.order - a.order;
        })
      );
    },
    archiveLayersHasItems() {
      return this.archiveLayers.length > 0;
    },
    indeterminate() {
      return (
        this.archiveLayers.some(l => l.visible) &&
        this.archiveLayers.some(l => !l.visible)
      );
    },
    allSelected() {
      return this.archiveLayers.every(l => l.visible);
    }
  },
  methods: {
    onToggled(expanded) {
      this.$emit('toggled', expanded);
      this.$store.commit(
        ARCHIVE_LAYERS_EXPANDED_SET,
        (expanded || {}).expanded
      );
    },
    onCheckboxChanged(value) {
      if (value) {
        this.archiveLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, {
            layerId: layer.id,
            visible: true
          });
        });
      } else {
        this.archiveLayers.forEach(layer => {
          this.$store.commit(SET_LAYER_VISIBILITY, {
            layerId: layer.id,
            visible: false
          });
        });
      }
    },
    setLayerExtent(extent) {
      this.$emit('set-layer-extent', extent);
    }
  }
};
</script>
